import nearestPoint from '@turf/nearest-point';
import _ from 'lodash';
import * as ActionTypes from '../actions/actionTypes';
import overlayConfig from '../config/overlays';

const initialState = { geo_json: null, active: null };

const getFmsExternalUrl = (stationId) => {
  const fms_overlay = _.keyBy(overlayConfig, 'id')['FMS'];
  return fms_overlay.config.externalLinkUrl.replaceAll('{stationId}', stationId);
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.POPULATE_FMS_DATA:
      return {
        ...state,
        geo_json: action.data
      };

    case ActionTypes.SET_ACTIVE_POINT:
    case ActionTypes.FIND_NEAREST_FMS:
      let active;
      if (state.geo_json && action.latlng) {
        const nearest = nearestPoint([action.latlng.lng, action.latlng.lat], state.geo_json).properties;
        // Ignore if outside 10km
        if (nearest.distanceToPoint < 10) {
          active = nearest;
          nearest.distanceToPoint = Math.round(nearest.distanceToPoint);
          nearest.externalUrl = getFmsExternalUrl(nearest.id);
        }
      }
      return {
        ...state,
        active
      };

    default:
      return state;

  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/fms.js